import { Component } from "preact";
import actions from "../../actions";
import { getAdvancedDatePicker } from "../../../common/asyncComponents/DatePicker";
import IconCalendar from "../../../common/components/icons/IconCalendar";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import IconCaretDown from "../../../common/components/icons/IconCaretDown";
import { TIME_FILTERS_VALUES } from "../../constants";
import { getDateRange } from "../../helpers/formatDate";
import DetailModal from "../modal/DetailModal";

const DATEPICKER_CONTAINER_ID = "datepicker_button_container";

class DatePickerFilterMobile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            datePicker: null,
        };

        this.togglePicker = this.togglePicker.bind(this);
        this.resetDatePicker = this.resetDatePicker.bind(this);
        this.onApply = this.onApply.bind(this);
        this.changeRangeOption = this.changeRangeOption.bind(this);
        this.renderButton = this.renderButton.bind(this);
        this.renderDateTitle = this.renderDateTitle.bind(this);
        this.renderModal = this.renderModal.bind(this);
        this.scrollTabs = this.scrollTabs.bind(this);
    }

    async togglePicker() {
        const { datePicker } = this.state;
        if (datePicker) this.resetDatePicker();
        else {
            const picker = await getAdvancedDatePicker();
            this.setState({ datePicker: picker });
        }
    }

    resetDatePicker() {
        this.setState({ datePicker: undefined });
    }

    onApply(dateRange) {
        if (dateRange && dateRange.from && dateRange.to)
            this.props.applyFilter(dateRange);

        this.resetDatePicker();
    }

    async changeRangeOption(value) {
        this.props.onTimeFilterChanged(value);

        this.resetDatePicker();

        const picker = await getAdvancedDatePicker();
        this.setState({ datePicker: picker });
    }

    async onDateRangeFilterChanged(dateRange) {
        this.props.onDateRangeFilterChanged(dateRange);
    }

    scrollTabs(id) {
        var element = document.getElementById(id);
        if (element) {
            var newPosition = element.offsetLeft;
            document.getElementById(DATEPICKER_CONTAINER_ID).scrollLeft =
                newPosition - 160;
        }
    }

    renderDateTitle(dateRange) {
        return getDateRange(dateRange, this.props.config.culture);
    }

    renderButton(value, getContentGtmId, getContentGa4Id, getGa4Name, showHighlighted, time, translate) {
        return (
            <button
                type="button"
                data-gtmid={getContentGtmId && getContentGtmId(value)}
                data-ga4event-clk-name={getGa4Name && getGa4Name}
                data-ga4event-element={getContentGa4Id && getContentGa4Id(value)}
                class={
                    showHighlighted && time === value
                        ? "fxs_c_datepicker_button fxs_c_datepicker_button_active"
                        : "fxs_c_datepicker_button"
                }
                onClick={() =>
                    this.changeRangeOption(value).then(() => {
                        this.scrollTabs(value);
                    })
                }
                id={value}
            >
                <span>
                    <span>{translate(value)}</span>
                </span>
            </button>
        );
    }

    renderModal(
        translate,
        time,
        showHighlighted,
        dateRange,
        getContentGtmId,
        getContentGa4Id,
        culture,
        datePicker,
        onChangeCustomFilter,
        getGa4Name
    ) {
        return (
            <div
                onMouseLeave={this.closePicker}
                class="fxs_c_DatePicker-Container"
            >
                <div class="fxs_c_datepicker_header">
                    <h2 class="fxs_headline_medium">
                        {translate("DatePickerMobile_ChooseDate")}
                    </h2>
                    <p class="fxs_entryPlain_txt_large">
                        {this.renderDateTitle(dateRange)}
                    </p>
                </div>

                <div
                    class="fxs_c_datepicker_button_area"
                    id={DATEPICKER_CONTAINER_ID}
                >
                    <div class="fxs_c_datepicker_button_slider">
                        <button
                            type="button"
                            disabled
                            class="fxs_c_datepicker_button"
                        ></button>
                        {this.renderButton(
                            TIME_FILTERS_VALUES.RecentNext,
                            getContentGtmId,
                            getContentGa4Id,
                            getGa4Name,
                            showHighlighted,
                            time,
                            translate
                        )}
                        {this.renderButton(
                            TIME_FILTERS_VALUES.Today,
                            getContentGtmId,
                            getContentGa4Id,
                            getGa4Name,
                            showHighlighted,
                            time,
                            translate
                        )}
                        {this.renderButton(
                            TIME_FILTERS_VALUES.Tomorrow,
                            getContentGtmId,
                            getContentGa4Id,
                            getGa4Name,
                            showHighlighted,
                            time,
                            translate
                        )}
                        {this.renderButton(
                            TIME_FILTERS_VALUES.Yesterday,
                            getContentGtmId,
                            getContentGa4Id,
                            getGa4Name,
                            showHighlighted,
                            time,
                            translate
                        )}
                        {this.renderButton(
                            TIME_FILTERS_VALUES.ThisWeek,
                            getContentGtmId,
                            getContentGa4Id,
                            getGa4Name,
                            showHighlighted,
                            time,
                            translate
                        )}
                        {this.renderButton(
                            TIME_FILTERS_VALUES.ThisMonth,
                            getContentGtmId,
                            getContentGa4Id,
                            getGa4Name,
                            showHighlighted,
                            time,
                            translate
                        )}
                        {this.renderButton(
                            TIME_FILTERS_VALUES.NextWeek,
                            getContentGtmId,
                            getContentGa4Id,
                            getGa4Name,
                            showHighlighted,
                            time,
                            translate
                        )}
                        {this.renderButton(
                            TIME_FILTERS_VALUES.NextMonth,
                            getContentGtmId,
                            getContentGa4Id,
                            getGa4Name,
                            showHighlighted,
                            time,
                            translate
                        )}
                        {this.renderButton(
                            TIME_FILTERS_VALUES.PreviousWeek,
                            getContentGtmId,
                            getContentGa4Id,
                            getGa4Name,
                            showHighlighted,
                            time,
                            translate
                        )}
                        {this.renderButton(
                            TIME_FILTERS_VALUES.PreviousMonth,
                            getContentGtmId,
                            getContentGa4Id,
                            getGa4Name,
                            showHighlighted,
                            time,
                            translate
                        )}
                        {this.renderButton(
                            TIME_FILTERS_VALUES.Custom,
                            getContentGtmId,
                            getContentGa4Id,
                            getGa4Name,
                            showHighlighted,
                            time,
                            translate
                        )}
                        <button
                            type="button"
                            disabled
                            class="fxs_c_datepicker_button"
                        ></button>
                    </div>
                </div>
                <datePicker.default
                    className="fxs_c_DatePicker"
                    onApply={this.onApply}
                    applyLabel={translate("DateSelectorApply")}
                    dateRange={dateRange}
                    locale={culture}
                    onDateRangeFilterChanged={(dateRange) =>
                        this.onDateRangeFilterChanged(dateRange).then(() => {
                            this.scrollTabs(TIME_FILTERS_VALUES.Custom);
                        })
                    }
                    onChangeCustomFilter={onChangeCustomFilter}
                />
            </div>
        );
    }

    render(
        {
            translate,
            config: { culture },
            dateRange,
            getButtonGtmId,
            getButtonGa4Id,
            getContentGtmId,
            getContentGa4Id,
            getGa4Name,
            onDateRangeFilterChanged,
            showHighlighted,
            time,
        },
        { datePicker }
    ) {
        return (
            <div class="fxs_c_datepicker-wrapper">
                <button
                    type="button"
                    onClick={this.togglePicker}
                    class={`fxs_btn fxs_c_datepicker_trigger_button fxs_btn_xsmall ${datePicker ? "fxs_c_datePicker_active" : ""
                        }`}
                    data-gtmid={getButtonGtmId}
                    data-ga4event-clk-name={getGa4Name && getGa4Name}
                    data-ga4event-element={getButtonGa4Id}
                >
                    <IconCalendar /> {this.renderDateTitle(dateRange)}
                    <IconCaretDown />
                </button>
                {datePicker && (
                    <DetailModal
                        handleClose={this.togglePicker}
                        body={this.renderModal(
                            translate,
                            time,
                            showHighlighted,
                            dateRange,
                            getContentGtmId,
                            getContentGa4Id,
                            culture,
                            datePicker,
                            onDateRangeFilterChanged,
                            getGa4Name
                        )}
                        componentDidMountAction={() =>
                            this.scrollTabs(this.props.time)
                        }
                    ></DetailModal>
                )}
            </div>
        );
    }
}

export default connectWithTranslations(
    "config",
    actions
)(DatePickerFilterMobile);
